import { createContext, use } from "react";

import type { AdminPublic } from "@/shared/api";

/**
 * Контекст сессии отдельным модулем от провайдера.
 *
 * Не ради красоты: файл, экспортирующий и компонент, и хук, ломает fast
 * refresh — Vite перезагружает страницу целиком вместо горячей замены.
 */
export interface AuthState {
  admin: AdminPublic | null;
  /** Пока идёт проверка токена, показывать форму входа нельзя: она мигнёт. */
  loading: boolean;
  isSuperadmin: boolean;
  setAdmin: (admin: AdminPublic) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const value = use(AuthContext);
  if (value === null) throw new Error("useAuth вызван вне AuthProvider");
  return value;
}
